module.exports = __webpack_public_path__ + "static/media/alert_active_assailant_selected.11699424.svg";